import type {
  AdminApi,
  AdminInspector,
  AdminOrg,
  AdminProfessional,
  AdminSource,
  RuleRelease,
  SupportGrant,
  WebhookDelivery,
} from './types.js';
import {
  INSPECTORS,
  ORGS,
  PROFESSIONALS,
  RULE_RELEASES,
  SOURCES,
  SUPPORT_GRANTS,
  WEBHOOKS,
} from './fixtures.js';

/**
 * In-memory AdminApi backed by fixtures so the platform-ops console is fully interactive
 * offline. Async to match the eventual network impl (HttpApi) — screens cannot tell them
 * apart.
 */
export class FixtureApi implements AdminApi {
  getSources(): Promise<AdminSource[]> {
    return Promise.resolve(SOURCES);
  }
  getRuleReleases(): Promise<RuleRelease[]> {
    return Promise.resolve(RULE_RELEASES);
  }
  getInspectors(): Promise<AdminInspector[]> {
    return Promise.resolve(INSPECTORS);
  }
  getProfessionals(): Promise<AdminProfessional[]> {
    return Promise.resolve(PROFESSIONALS);
  }
  getOrgs(): Promise<AdminOrg[]> {
    return Promise.resolve(ORGS);
  }
  getSupportGrants(): Promise<SupportGrant[]> {
    return Promise.resolve(SUPPORT_GRANTS);
  }
  getWebhooks(): Promise<WebhookDelivery[]> {
    return Promise.resolve(WEBHOOKS);
  }
}
